export default "__VITE_ASSET__C_LDhfp6__"